import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { ComponentProps } from 'react';
import { Modal, ModalContent, ModalDescription, ModalTitle } from '../../../../design-system/modal/modal';
import { AccountMappingModalContent } from './account-mapping-modal-content';

type AccountMappingModalProps = {
  isOpen: boolean;
  onClose: () => void;
} & ComponentProps<typeof AccountMappingModalContent>;

export const AccountMappingModal = ({ isOpen, onClose, ...rest }: AccountMappingModalProps) => {
  return (
    <Modal open={isOpen} onOpenChange={onClose}>
      <ModalContent className="h-full w-full overflow-auto bg-muted p-7">
        <VisuallyHidden>
          <ModalTitle>Map Seapoint accounts to Xero bank accounts</ModalTitle>

          <ModalDescription>Map Seapoint accounts to Xero bank accounts</ModalDescription>
        </VisuallyHidden>

        <AccountMappingModalContent {...rest} />
      </ModalContent>
    </Modal>
  );
};
